import React from "react";
import { motion } from "framer-motion";
// import Image from "next/image"
import element5 from "../assets/svg/element-5.svg";
import element1 from "../assets/svg/element-4.svg";

const plans = [
  {
    name: "Intro",
    price: "8,000",
    period: "Every year",
    description: "Basic Plan for Small Users",
    registration: "+₹29,999 License Registration",
    trial: "30 day free trial",
    buttonClass: "bg-[#27214D] text-white hover:bg-[#1D1938]",
    features: [
      "Patti Book Entry",
      "Supplier Payment",
      "Payment Voucher Entry",
      "Bank Record",
      "Basic Analytics",
      "Single User Login",
      "Limited Record Storage (up to 20000 transactions)",
      "Email Support Only",
    ],
  },
  {
    name: "Plus Plan",
    price: "12,000",
    period: "Every year",
    description: (
      <span className="text-white">Mid-Tier Plan for Growing Businesses</span>
    ),
    registration: "+₹29,999 License Registration",
    trial: "30 day free trial",
    isPopular: true,
    buttonClass: "bg-white text-[#27214D] hover:bg-gray-50",
    features: [
      "All Intro Plan Features",
      "Vehicle Logistics Management",
      "Advanced Analytics",
      "Invoice Printing (Thermal and Standard)",
      "User Authority (Add/Edit Roles)",
      "Multiple User Logins (up to 4 users)",
      "Data Backup and Restore Options",
      "WhatsApp Notifications for Transactions",
      "Chat and Phone Support",
    ],
  },
  {
    name: "Elite Plan",
    price: "15,000",
    period: "Every year",
    description: "Premium Plan for Large Enterprises",
    registration: "+₹29,999 License Registration",
    trial: "30 day free trial",
    buttonClass: "bg-[#27214D] text-white hover:bg-[#1D1938]",
    features: [
      "All Plus Plan Features",
      "Full Accounting Suite",
      "Staff Attendance Tracking",
      "Advanced Reporting and Analytics",
      "Multiple User Logins (up to 8 users)",
      "SMS and WhatsApp Integration",
      "Priority Support (24x7 with Dedicated Manager)",
    ],
  },
];

const PricingPlans = () => {
  return (
    <section className="py-8 sm:py-12 md:py-16 bg-[#F6F6F6] relative overflow-hidden">
      <div className="max-w-[1570px] mx-auto px-4 sm:px-6 md:px-8 lg:px-[185px]">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="text-center mb-8 sm:mb-12"
        >
          <h2
            className="text-3xl sm:text-4xl md:text-[50px] leading-tight font-bold text-[#281a39] mb-2 sm:mb-4"
            style={{ fontFamily: "Space Grotesk" }}
          >
            Explore Our Pricing Plans
          </h2>
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5, delay: 0.2 }}
            className="text-base sm:text-lg md:text-[16px] leading-relaxed text-[#281a39]"
            style={{ fontFamily: "Space Grotesk" }}
          >
            Use this area to describe one of your memberships.
          </motion.p>
        </motion.div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 relative">
          {plans.map((plan, index) => (
            <motion.div
              key={plan.name}
              initial={{ opacity: 0, y: 50 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.2, ease: [0.43, 0.13, 0.23, 0.96] }}
              whileHover={{ y: -10, scale: 1.05, transition: { duration: 0.3 } }}
              className={`relative rounded-2xl overflow-visible h-full flex flex-col ${plan.isPopular ? "bg-[#281B39] text-white" : "bg-[#BDE9FB] text-[#281a39]"}`}
            >
              {plan.isPopular && (
                  <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 border-2 border-black bg-[#B8E4FF] text-[#2D1A45] px-4 py-1 rounded-md text-xs sm:text-sm font-medium z-20">
                    Best Value
                  </div>
              
              )}
              <div className="flex-1 flex flex-col justify-between">
                <div className="flex-1 flex flex-col justify-between p-4 sm:p-6 md:p-8">
                  <motion.h3
                    initial={{ opacity: 0, x: -20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ delay: 0.4, duration: 0.3 }}
                    className="text-xl sm:text-2xl md:text-[22px] font-semibold mb-2 sm:mb-4"
                    style={{ fontFamily: "Space Grotesk" }}
                  >
                    {plan.name}
                  </motion.h3>
                  <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 0.4, duration: 0.3 }}
                    className="mb-4 sm:mb-6"
                    style={{ fontFamily: "Space Grotesk" }}
                  >
                    <span className="text-xl sm:text-2xl">₹</span>
                    <span className="text-4xl sm:text-5xl md:text-[60px] font-bold">{plan.price}</span>
                    <span className="block text-base sm:text-sm ml-1">{plan.period}</span>
                  </motion.div>
                  <motion.p
                    className="text-xs sm:text-sm mb-2 sm:mb-4 leading-relaxed"
                    style={{ lineHeight: "1.5" }}
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.7, duration: 0.3 }}
                  >
                    {plan.registration}
                  </motion.p>
                  <motion.p
                    className="mb-2 sm:mb-4 font-bold text-[#1a1a1a]"
                    style={{ fontFamily: "Roboto, sans-serif", lineHeight: "1.5" }}
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.6, duration: 0.3 }}
                  >
                    {plan.description}
                  </motion.p>
                  <motion.p
                    className="text-xs sm:text-sm mb-4 sm:mb-8 leading-relaxed"
                    style={{ lineHeight: "1.5" }}
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.8, duration: 0.3 }}
                  >
                    {plan.trial}
                  </motion.p>
                  <motion.button
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.98 }}
                    className={`w-full py-2 sm:py-3 px-4 sm:px-6 rounded-lg font-semibold transition-colors duration-200 ${plan.buttonClass}`}
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 1, duration: 0.3 }}
                  >
                    Start Free Trial
                  </motion.button>
                </div>
              </div>
              <div className="p-4 sm:p-6 md:p-8 bg-[#EAE0DA] text-[#281a39] flex-1">
                <motion.ul
                  className="space-y-3 sm:space-y-6"
                  initial={{ opacity: 0 }}
                  whileInView={{ opacity: 1 }}
                  viewport={{ once: false, amount: 0.3 }}
                  transition={{ duration: 0.6 }}
                >
                  {plan.features.map((feature, featureIndex) => (
                    <motion.li
                      key={featureIndex}
                      initial={{ opacity: 0, x: -20 }}
                      animate={{ opacity: 1, x: 0 }}
                      transition={{ duration: 0.3, delay: index * 0.1 + featureIndex * 0.05, ease: "easeOut" }}
                      className="flex items-center space-x-2 sm:space-x-3"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Check icon" width="24" height="24" viewBox="0 0 24 24">
                        <path class="highlighted" fill="#281A39" fill-rule="evenodd" d="M10.785 14.961L8 12.176L8.707 11.469L10.785 13.547L15.293 9.039L16 9.746L10.785 14.961ZM12 4C7.582 4 4 7.582 4 12C4 16.418 7.582 20 12 20C16.419 20 20 16.418 20 12C20 7.582 16.419 4 12 4Z"></path>
                      </svg>
                      <span
                        className="text-xs sm:text-sm font-semibold text-black"
                        style={{ fontFamily: "Roboto, sans-serif", lineHeight: "1.5" }}
                      >
                        {feature}
                      </span>
                    </motion.li>
                  ))}
                </motion.ul>
              </div>
            </motion.div>
          ))}
         
          <div className="absolute bottom-[-50px] left-[-50px] w-[150px] h-[150px] z-10 hidden lg:block">
            <img src={element5} alt="Decorative element 1" className="object-contain w-full h-full" />
          </div>
          <div className="absolute bottom-[-50px] right-[-50px] w-[150px] h-[150px] z-10 hidden lg:block">
            <img src={element1} alt="Decorative element 2" className="object-contain w-full h-full" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default PricingPlans;
